export default "__VITE_ASSET__CcOnQ7Bc__"